var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 247 210",
    style: {
      enableBackground: "new 0 0 247 210"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#F5F6FA;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#BDBDBD;}\n\t.st3{fill:none;stroke:#767676;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#767676;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#BDBDBD;stroke:#767676;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:#EAEAEA;}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#EAEAEA;}\n\t.st9{fill:#FFFFFF;stroke:#767676;}\n\t.st10{fill:none;stroke:#979797;}\n\t.st11{fill:#BDBDBD;}\n\t.st12{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.5,182.8c51.1,0,92.5-40.9,92.5-91.4C247,40.9,205.6,0,154.5,0C103.4,0,62,40.9,62,91.4 C62,141.9,103.4,182.8,154.5,182.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.3,81.3c1.6,0,3.2-1.8,3.2-3.9c0-2.2-1.8-3.9-3.9-3.9c-2.2,0-3.8,1.4-3.8,3.6c1,0.6,1.6,0.9,2.3,1.6 C203.8,79.4,204.3,79.9,205.3,81.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M206.3,81.3c2.2,0,3.9-1.8,3.9-3.9c0-2.2-1.8-3.9-3.9-3.9c-2.2,0-3.9,1.8-3.9,3.9 C202.4,79.6,204.1,81.3,206.3,81.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M205.3,81.3c1.6,0,3.2-1.8,3.2-3.9c0-2.2-1.8-3.9-3.9-3.9c-2.2,0-3.8,1.4-3.8,3.6c1,0.6,1.6,0.9,2.3,1.6 C203.8,79.4,204.3,79.9,205.3,81.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M219,135.5c6.7,0,12.2,0,12.2,0c0-2-3.5-6.5-8.4-8.1c0-1-0.4-4-3.8-4c-3.3,0-3.9,3.1-3.9,4 c-4.8,1.5-8.3,5.6-8.3,8.1C206.7,135.5,212.2,135.5,219,135.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M219,129.4c1,0,1.7-0.8,1.7-1.7c0-1-0.8-1.7-1.7-1.7c-1,0-1.7,0.8-1.7,1.7C217.2,128.6,218,129.4,219,129.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M233.8,107.6c2.4,0,4.4-2,4.4-4.4c0-2.4-2-4.4-4.4-4.4c-2.4,0-4.4,2-4.4,4.4 C229.4,105.6,231.4,107.6,233.8,107.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M233.8,104.9c1,0,1.7-0.8,1.7-1.7c0-1-0.8-1.7-1.7-1.7c-1,0-1.7,0.8-1.7,1.7C232,104.2,232.8,104.9,233.8,104.9 z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M230.1,105.6c0,0,0.4,0.5,0.8,1c0.5,0.4,1.1,0.7,1.1,0.7l-10.2,17.5c0,0-0.3-0.4-0.9-0.8 c-0.6-0.4-1.4-0.5-1.4-0.5L230.1,105.6z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M205,138.5c0-1.7,1.3-3,3-3h21.9c1.7,0,3,1.3,3,3v0.5H205V138.5z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M206.7,138.5c0-1.7,1.3-3,3-3h21.9c1.7,0,3,1.3,3,3v0.5h-27.9V138.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M205,138.5c0-1.7,1.3-3,3-3h21.9c1.7,0,3,1.3,3,3v0.5H205V138.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M186.1,77.9c0.4-0.3,0.9-0.4,1.3,0l19.3,16.5c0.4,0.3,0.5,0.9,0.2,1.3l-0.4,0.6c-0.3,0.5-1,0.6-1.5,0.2 L185.5,80c-0.5-0.4-0.5-1.1,0-1.5L186.1,77.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.8,78.2c0,0,9.4-4.7,15.3,0.5c5.9,5.2,3.3,15.3,3.3,15.3L187.8,78.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M189.5,79.2c0,0,9.4-4.7,15.3,0.5c5.9,5.2,3.3,15.3,3.3,15.3L189.5,79.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M187.8,78.2c0,0,9.4-4.7,15.3,0.5c5.9,5.2,3.3,15.3,3.3,15.3L187.8,78.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M191,84.6l8.1,6.9c0,0-3.7,2.2-6.5,0C189.7,89.3,191,84.6,191,84.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M206.5,81.1l23.3,20.3c0,0,0.4-0.7,0.9-1.2c0.5-0.5,1.4-0.9,1.4-0.9l-23.8-20.3c0,0-0.2,0.7-0.7,1.2 C207.1,80.7,206.5,81.1,206.5,81.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.9,147.8h12.2l-3,61.2h-9.2V147.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.6,147.8h-12.2l3,61.2h9.2V147.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M168.4,147.8h12.2l-3,61.2h-9.2V147.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M238.1,147.8h-12.2l3,61.2h9.2V147.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M180.2,147.8h47l0.5,9.1h-47.9L180.2,147.8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M164.9,147.8h12.2l-3,61.2h-9.2V147.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M234.6,147.8h-12.2l3,61.2h9.2V147.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M177.1,147.8h45.3l0.4,9.1h-46.2L177.1,147.8z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M161.8,139h75.1c1.7,0,3,1.3,3,3v2.7c0,1.7-1.3,3-3,3h-75.1c-1.7,0-3-1.3-3-3V142 C158.8,140.4,160.1,139,161.8,139z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M168.4,117.2h17.4v13.1c0,4.8-3.9,8.7-8.7,8.7l0,0c-4.8,0-8.7-3.9-8.7-8.7V117.2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M171,115.4h17.4v13.1c0,4.8-3.9,8.7-8.7,8.7l0,0c-4.8,0-8.7-3.9-8.7-8.7V115.4z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M168.4,117.2h17.4v13.1c0,4.8-3.9,8.7-8.7,8.7l0,0c-4.8,0-8.7-3.9-8.7-8.7V117.2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M168.4,121.3c0,0-4.7,1.2-4.7,5.5c0,4.3,4.7,5.2,4.7,5.2v-2.9c0,0-2.3-0.4-2.3-2.3c0-1.9,2.3-2.6,2.3-2.6V121.3 z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M6.2,123.1c0-2.8,2.2-5,5-5h16.5c2.8,0,5,2.2,5,5v17.2c0,11,9,20,20,20h55.6c11,0,20-9,20-20v-17.2 c0-2.8,2.2-5,5-5h16.2c2.8,0,5,2.2,5,5v22.1c0,24.9-20.1,45-45,45H51.2c-24.9,0-45-20.1-45-45V123.1z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M117.2,185.6l2.9,18.9c0,0,0.6,4.3-2.2,4.3c-2.8,0-4.8-4.3-4.8-4.3l-8.7-18.9H117.2z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M37.9,185.6l-2.9,18.9c0,0-0.6,4.3,2.2,4.3s4.8-4.3,4.8-4.3l8.7-18.9H37.9z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114.5,185.6l2.9,18.9c0,0,0.6,4.3-2.2,4.3c-2.8,0-4.8-4.3-4.8-4.3l-8.7-18.9H114.5z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M35.3,185.6l-2.9,18.9c0,0-0.6,4.3,2.2,4.3c2.8,0,4.8-4.3,4.8-4.3l8.7-18.9H35.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1,118.5c0-2.8,2.2-5,5-5h16.5c2.8,0,5,2.2,5,5v17.2c0,11,9,20,20,20H103c11,0,20-9,20-20v-17.2 c0-2.8,2.2-5,5-5h16.2c2.8,0,5,2.2,5,5v22.1c0,24.9-20.1,45-45,45H46c-24.9,0-45-20.1-45-45V118.5z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M28,114l2.7-35.6c0,0,0.6-12.2,8.6-20.2c8.1-8,17.9-9.2,17.9-9.2H106c0,0,13.6,1.8,20.1,9.2 c6.5,7.4,7.6,20.2,7.6,20.2l2.8,35.6l0,0c-3.1,0-5.6,2.5-5.6,5.6v16.6c0,11-9,20-20,20H55.5c-11,0-20-9-20-20V120c0-3.3-2.7-6-6-6 H28z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M20.1,113.1l2.7-35.6c0,0,0.6-12.2,8.6-20.2c8.1-8,17.9-9.2,17.9-9.2h48.8c0,0,13.6,1.8,20.1,9.2 c6.5,7.4,7.6,20.2,7.6,20.2l2.8,35.6l0,0c-3.1,0-5.6,2.5-5.6,5.6v17.6c0,10.5-8.5,19-19,19H46.6c-10.5,0-19-8.5-19-19v-17.2 c0-3.3-2.7-6-6-6H20.1z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M46.3,125.1h64.4c7.7,0,14,6.3,14,14v0c0,7.7-6.3,14-14,14H46.3c-7.7,0-14-6.3-14-14v0 C32.4,131.3,38.6,125.1,46.3,125.1z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42.9,127.7h64.4c7.7,0,14,6.3,14,14v0c0,7.7-6.3,14-14,14H42.9c-7.7,0-14-6.3-14-14v0 C28.9,133.9,35.1,127.7,42.9,127.7z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1,118.5c0-2.8,2.2-5,5-5h16.5c2.8,0,5,2.2,5,5v17.2c0,11,9,20,20,20H103c11,0,20-9,20-20v-17.2 c0-2.8,2.2-5,5-5h16.2c2.8,0,5,2.2,5,5v22.1c0,24.9-20.1,45-45,45H46c-24.9,0-45-20.1-45-45V118.5z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M33.2,185.4l1.2-3.9l50.7-1.4c0,0,27-2.2,38.9-5.3c11.9-3.2,22.9-15.4,22.9-15.4s-6.7,16.1-19.5,22.1 c-12.9,6-35.2,4-35.2,4H33.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.679d49fa88e1056476c11206172cb100.svg";
export { ForwardRef as ReactComponent };